<div *ngIf="$loading | async" class="spinner-overlay flex items-center justify-center">
    <span class="loading loading-spinner loading-lg"></span>
</div>
